import { useEffect } from 'react';
import { getUcUiResponse, UC_UI_RESPONSE_STATE } from './getUcUiResponse';

const USERCENTRICS_EVENT_LISTENER = 'onUsercentricsUpdate';

export type ExecuteOnUcUiChangeProps = {
    onLoading?: () => void;
    onSuccess?: () => void;
    onError?: () => void;
    onUpdate?: () => void;
};

export const executeOnUcUiChange = (props: ExecuteOnUcUiChangeProps) => {
    const { onLoading, onSuccess, onError, onUpdate } = props;
    const ucUiResponse = getUcUiResponse();

    useEffect(() => {
        if (!onUpdate) {
            return () => {};
        }
        if (ucUiResponse !== UC_UI_RESPONSE_STATE.SUCCESS) {
            return () => {};
        }

        window.addEventListener(USERCENTRICS_EVENT_LISTENER, onUpdate);
        return () => {
            window.removeEventListener(USERCENTRICS_EVENT_LISTENER, onUpdate);
        };
    }, [onUpdate, ucUiResponse]);

    useEffect(() => {
        switch (ucUiResponse) {
            case UC_UI_RESPONSE_STATE.LOADING:
                if (onLoading) {
                    onLoading();
                }
                break;
            case UC_UI_RESPONSE_STATE.SUCCESS:
                if (onSuccess) {
                    onSuccess();
                }
                break;
            case UC_UI_RESPONSE_STATE.ERROR:
                if (onError) {
                    onError();
                }
                break;
        }
    }, [ucUiResponse]);
};
